import { certificateCourseData } from "../CertificateCourse.Data";

const defaultCss = "col-md-6 mb-2";
const hiddenCss = "col-md-6 mb-2 d-none";
const defaultValidation = [{ type: "require" }];
const removeValidation = [];

const getFieldById = (fields, id) => fields.find((item) => item.id === id);

const setFieldStyleAndValidation = (field, containerCss, validation) => {
    field.style.containerCss = containerCss;
    field.validation = validation;
};

// const applyOptionsFilter = (field, excludeValues = []) => {
//     if (!field?.fieldSetting) return;
//     if (!field.fieldSetting._allOptions && field.fieldSetting.options?.length) {
//         field.fieldSetting._allOptions = field.fieldSetting.options;
//     }
//     const fullList = field.fieldSetting._allOptions || field.fieldSetting.options || [];
//     field.fieldSetting.options = excludeValues.length ? fullList.filter((opt) => !excludeValues.includes(opt.value)) : fullList;
// };
const applyOptionsFilter = (field, { onlyValues = [], excludeValues = [] } = {}) => {
    if (!field?.fieldSetting) return;

    // store the original full list once so it can always be restored
    if (!field.fieldSetting._allOptions && field.fieldSetting.options?.length) {
        field.fieldSetting._allOptions = field.fieldSetting.options;
    }

    const fullList = field.fieldSetting._allOptions || field.fieldSetting.options || [];

    let filtered = fullList;
    if (onlyValues.length) {
        filtered = fullList.filter((opt) => onlyValues.includes(opt.value));
    } else if (excludeValues.length) {
        filtered = fullList.filter((opt) => !excludeValues.includes(opt.value));
    }

    field.fieldSetting = { ...field.fieldSetting, options: filtered };
};

// value 2 -> only option 7 in dropdown, auto-selected
// value 1 -> all options except 7
// other   -> all options
const applyP2Options = (field, state, value) => {
    if (value === 1) {
        applyOptionsFilter(field, { onlyValues: [7] });
        state.gmapCertificateTypeP2Id = 7;
    } else if (value === 2) {
        applyOptionsFilter(field, { excludeValues: [7] });
        if (state.gmapCertificateTypeP2Id === 7) {
            state.gmapCertificateTypeP2Id = null; // clear old auto-selection
        }
    } else {
        applyOptionsFilter(field);
    }
};


export const handleConditionBaseFields = (value, section) => {
    if (section !== "gmaPathwayTypeID") return certificateCourseData;

    const updated = {
        ...certificateCourseData,
        formFields: certificateCourseData.formFields.map(f => ({ ...f, style: { ...f.style } })),
        initialState: { ...certificateCourseData.initialState }
    };

    const gmapCertificateTypeP2Field = updated.formFields.find(f => f.id === "gmapCertificateTypeP2Id");
    const IHLCertificateTypeField = updated.formFields.find(f => f.id === "IHLCertificateTypeId");

    updated.initialState.gmaPathwayTypeID = value;

    if (value === 1) {
        updated.initialState.gmapCertificateTypeP1Id = value;
    } else {
        updated.initialState.gmapCertificateTypeP1Id = null;
        updated.initialState.IHLCertificateTypeId = null;
    }

    setFieldStyleAndValidation( IHLCertificateTypeField, value === 1 ? "col-md-4 mb-4" : hiddenCss, value === 1 ? defaultValidation : removeValidation );
    setFieldStyleAndValidation(gmapCertificateTypeP2Field, value === 2 || value === 1 ? defaultCss : hiddenCss, value === 2 || value === 1 ? defaultValidation : removeValidation );

      applyP2Options(gmapCertificateTypeP2Field, certificateCourseData.initialState, value);

    Object.assign(certificateCourseData, updated);

    return updated;
};


export const handleCourseConditionBaseFields = (value, section) => {
    if (section !== "gmaPathwayTypeID") return certificateCourseData;
    const gmapCertificateTypeP2Field = getFieldById("gmapCertificateTypeP2Id");
    const IHLCertificateTypeField = getFieldById("IHLCertificateTypeId");

    certificateCourseData.initialState.gmaPathwayTypeID = value;
    if (value === 1) {
        certificateCourseData.initialState.gmapCertificateTypeP1Id = value;
    }

    if (section === "gmaPathwayTypeID") {
        setFieldStyleAndValidation(IHLCertificateTypeField, value === 1 ? defaultCss : hiddenCss, value === 1 ? defaultValidation : removeValidation);
        setFieldStyleAndValidation(gmapCertificateTypeP2Field, (value === 2 || value === 1) ? defaultCss : hiddenCss, value === 2 || value === 1 ? defaultValidation : removeValidation);

             applyP2Options(gmapCertificateTypeP2Field, certificateCourseData.initialState, value);
    }

    return certificateCourseData;
}